export default {"src":"/v1/_next/static/media/feedback.fdd10ee9.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};